import React, { ReactNode } from 'react';
import { WprContainer } from '../../../wpr-framework/component/controls/WprContainer';
import { WprDiv } from '../../../wpr-framework/component/controls/WprDiv';
import { WprAnchor } from '../../../wpr-framework/component/controls/WprAnchor';
import { WprBaseViewComponent } from '../../../wpr-framework/view/component/WprBaseViewComponent';
import { FooterComponentView } from './FooterComponentView';

/**
 * フッターコンポーネント
 */
export class FooterComponent extends WprBaseViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) { 
		super(new FooterComponentView(), props); 
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
  	 * 描画
   	 */
	public onRender(): ReactNode {
		return (
			<>
				<footer>
					<div className="nav">
						<div className="wrap">
							<ul>
								<li><a href="https://www.zurich.co.jp/recommendation_env/"	target="_blank">推奨環境</a></li>
								<li><a href="https://www.zurich.co.jp/agreement/"			target="_blank">個人情報保護方針</a></li>
								<li><a href="https://www.zurich.co.jp/agreement02/"			target="_blank">勧誘方針</a></li>
								<li><a href="https://www.zurich.co.jp/profit_reciprocity/"	target="_blank">利益相反管理方針</a></li>
								<li><a href="https://www.zurich.co.jp/agreement03/"			target="_blank">重要なご案内</a></li>
								<li><a href="https://www.zurich.co.jp/myzurichta/"			target="_blank">サイトご利用規約</a></li>
							</ul>
							<div className="copyright">
								<span>© Zurich.All rights reserved.</span>
							</div>
						</div>
					</div>
					<WprContainer view={this.view} mode="show">
						<WprDiv view={this.view} name='cpagetop' className="c-pagetop">
							<WprAnchor view={this.view} name='pagetop'></WprAnchor>
						</WprDiv>
					</WprContainer>
				</footer>
			</>
		);
	}
	// --------------------------------------------------------------------------
}